module.exports = __webpack_public_path__ + "static/media/ICON_FIND_ECP_ACTIVE.4b660164.svg";